import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IExtracao, IExtracaoTableItem } from "../../../models";

interface IExtracaoState {
    extracoes: IExtracaoTableItem[]
    extracaoAberta?: IExtracao
    extracoesTotal: number
    extracoesPagination: {
        page: number
        limit: number
    }
    extracaoListFiltros: {
        nome?: string
        inclusaoStart?: Date
        inclusaoEnd?: Date
        idUsuario?: number
        idVelesGeoListaCidade?:number;
        usuario?: string
        cliente?: string
        nomeUsuario?: string
    }
}

const initialState: IExtracaoState = {
    extracoes: [],
    extracoesTotal: 0,
    extracoesPagination: {
        page: 0,
        limit: 0
    },
    extracaoListFiltros: {
        nome: undefined,
        inclusaoStart: undefined,
        inclusaoEnd: undefined,
        idUsuario: undefined,
        cliente: undefined,
        usuario: undefined,
        nomeUsuario: undefined
    }
}

const extracaoSlice = createSlice({
    name: 'extrações',
    initialState,
    reducers: {
        setExtracoesState(state, action: PayloadAction<{
            extracoes: IExtracaoTableItem[]
            total: number
        }>) {
            state.extracoes = action.payload.extracoes
            state.extracoesTotal = action.payload.total
        },
        setExtracaoAbertaState(state, action: PayloadAction<IExtracao>) {
            state.extracaoAberta = action.payload
        },
        resetExtracaoAbertaState(state) {
            state.extracaoAberta = initialState.extracaoAberta
        },
        setExtracoesTotalState(state, action: PayloadAction<number>) {
            state.extracoesTotal = action.payload
        },
        setExtracoesPaginationState(state, action: PayloadAction<{
            page: number
            limit: number
        }>) {
            state.extracoesPagination = {
                page: action.payload.page,
                limit: action.payload.limit            
            }
        },
        setExtracaoListFiltrosNomeState(state, action: PayloadAction<string>) {
            state.extracaoListFiltros.nome = action.payload
        },
        resetExtracaoListFiltrosNomeState(state) {
            state.extracaoListFiltros.nome = initialState.extracaoListFiltros.nome
        },
        setExtracaoListFiltrosInclusaoStartState(state, action: PayloadAction<Date>) {
            state.extracaoListFiltros.inclusaoStart = action.payload
        },
        resetExtracaoListFiltrosInclusaoStartState(state) {
            state.extracaoListFiltros.inclusaoStart = initialState.extracaoListFiltros.inclusaoStart
        },
        setExtracaoListFiltrosInclusaoEndState(state, action: PayloadAction<Date>) {
            state.extracaoListFiltros.inclusaoEnd = action.payload
        },
        resetExtracaoListFiltrosInclusaoEndState(state) {
            state.extracaoListFiltros.inclusaoEnd = initialState.extracaoListFiltros.inclusaoEnd
        },
        setExtracaoListFiltrosIdUsuarioState(state, action: PayloadAction<number>) {
            state.extracaoListFiltros.idUsuario = action.payload
        },
        resetExtracaoListFiltrosIdUsuarioState(state) {
            state.extracaoListFiltros.idUsuario = initialState.extracaoListFiltros.idUsuario
        },
        setExtracaoListFiltrosUsuarioState(state, action: PayloadAction<string>) {
            state.extracaoListFiltros.usuario = action.payload
        },
        resetExtracaoListFiltrosUsuarioState(state) {
            state.extracaoListFiltros.usuario = initialState.extracaoListFiltros.usuario
        },
        setExtracaoListFiltrosNomeUsuarioState(state, action: PayloadAction<string>) {
            state.extracaoListFiltros.nomeUsuario = action.payload
        },
        resetExtracaoListFiltrosNomeUsuarioState(state) {
            state.extracaoListFiltros.nomeUsuario = initialState.extracaoListFiltros.nomeUsuario
        },
        setExtracaoListFiltrosClienteState(state, action: PayloadAction<string>) {
            state.extracaoListFiltros.cliente = action.payload
        },
        resetExtracaoListFiltrosClienteState(state) {
            state.extracaoListFiltros.cliente = initialState.extracaoListFiltros.cliente
        },
        resetExtracaoListFiltrosState(state) {
            state.extracaoListFiltros = initialState.extracaoListFiltros
        }
    }
})

export const {
    resetExtracaoAbertaState,
    resetExtracaoListFiltrosIdUsuarioState,
    resetExtracaoListFiltrosInclusaoEndState,
    resetExtracaoListFiltrosInclusaoStartState,
    resetExtracaoListFiltrosNomeState,
    resetExtracaoListFiltrosState,
    resetExtracaoListFiltrosClienteState,
    resetExtracaoListFiltrosUsuarioState,
    resetExtracaoListFiltrosNomeUsuarioState,
    setExtracaoAbertaState,
    setExtracoesPaginationState,
    setExtracoesState,
    setExtracoesTotalState,
    setExtracaoListFiltrosIdUsuarioState,
    setExtracaoListFiltrosInclusaoEndState,
    setExtracaoListFiltrosInclusaoStartState,
    setExtracaoListFiltrosNomeState,
    setExtracaoListFiltrosClienteState,
    setExtracaoListFiltrosUsuarioState,
    setExtracaoListFiltrosNomeUsuarioState

} = extracaoSlice.actions

export const extracoesReducer = extracaoSlice.reducer